import { useCallback, useMemo } from 'react'

import { useNavigationParams } from '../../system/useNavigationParams'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { useLazilyResolveCreateValueOperations } from './useLazilyResolveCreateValueOperations'

type FetchProps = {
  parameterDefinitionId: string
}

export const useLazyLoadAllParameterValuesForView = (isFlattened: boolean) => {
  const { applicationParameterValues } = useApplicationViewOperationsContext()
  const { mutateAsync, isPending } = useLazilyResolveCreateValueOperations()
  const { server } = useNavigationParams()

  const load = useCallback(
    ({ parameterDefinitionId }: FetchProps) => {
      const valuesForId =
        applicationParameterValues.get(parameterDefinitionId) ?? []

      return mutateAsync({ server, allValues: valuesForId, isFlattened })
    },
    [isFlattened, applicationParameterValues, server, mutateAsync],
  )

  return useMemo(() => ({ mutateAsync: load, isPending }), [isPending, load])
}
